import { MONO_STYLE } from '@/components/common/MonoId'

interface Props {
  id: string
  length?: number
}

export function TruncatedId({ id, length = 8 }: Props) {
  return (
    <span title={id} style={MONO_STYLE}>
      {id.slice(0, length)}...
    </span>
  )
}
